import React from "react";

import { SoilSightLoader } from "components";

export const OnboardingCalculatingState = () => (
  <div className="onboarding-calculating" data-testid="onboarding-calculating">
    <SoilSightLoader dataTestId="onboarding-calculating-spinner" />
  </div>
);
